import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface CompanyStep2Fields {
	negativeLastClosedBusinessYear: boolean;
	negativeEquity: boolean;
	hasOverdueNavDebt: boolean;
	hasOverdueLoanDebt: boolean;
	hasAnotherCompanyUnderLiquidation: boolean;
}

export class CompanyStep2 extends AbstractStep<CompanyStep2Fields> {
	protected renderContent(_values: CompanyStep2Fields, form: FormApi<CompanyStep2Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						name="negativeLastClosedBusinessYear"
						label="Utolsó lezárt pénzügyi év üzemi/adózott eredménye negatív?"
						required
					/>
					<FormDecidable
						name="negativeEquity"
						label="Utolsó lezárt pénzügyi év saját tőkéje negatív?"
						required
					/>
					<FormDecidable name="hasOverdueNavDebt" label="Van lejárt NAV tartozása a cégednek?" required />
					<FormDecidable name="hasOverdueLoanDebt" label="Van a cégnek lejárt hiteltartozása?" required />
					<FormDecidable
						name="hasAnotherCompanyUnderLiquidation"
						label="Van a tulajdonosi körben felszámolás alatt álló cég?"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "CompanyStep2";
	}
}
